import { render, staticRenderFns } from "./proof-view-tools.vue?vue&type=template&id=8c30e484&scoped=true&"
import script from "./proof-view-tools.vue?vue&type=script&lang=js&"
export * from "./proof-view-tools.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-tools.vue?vue&type=style&index=0&id=8c30e484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c30e484",
  null
  
)

export default component.exports